//Файл errors.ts одинаковый как на бэке так и на фронте. Для синхронизации числовых кодов ошибок

//Коды ошибок API
export enum ApiErrorCode{
  //нет ошибки
  no_error = 0,
  
  //Authorization required. Нет токена token в заголовке. (в не админки)
  authorization_required,

  //Authorization required (login, password). Проблемы с авторизацией по токену session-token в заголовке (в админке)
  authorization_required_with_login_password,

  //Login failed. Вход в систему не удался.
  //Причины: email или телефон не тот, пароль не тот, пользователь заблокирован.
  login_failed,

  //session-token отсутствует в заголовке
  session_token_is_missing,

  //Email не подтвержден. Возможно он уже был подтвержден
  confirm_email_failed,

  //Другая ошибка
  another_error,

  //Parameter is missing
  parameter_is_missing = 20,

  //slug не найден
  slug_not_found,

  //страница не найдена
  page_not_found,

  //статья не найдена
  article_not_found,

  //Корзина пустая
  basket_is_empty,

  //Магазин не привязан к пользователю
  vendor_is_missing_on_user,

  //Пользователь не найден
  user_not_found,

  //Неверный пароль
  wrong_pwd,

  //Email уже существует
  email_already_exists,

  //ИНН уже существует
  inn_already_exists,

  //ИНН отсутствует
  inn_not_found,

  //Импорт уже идет!
  import_is_already_in_progress,

  //Ошибка авторизации по звонку
  make_call_error,

  //Товара нет в наличии или нет желаемого кол-ва
  catalog_item_is_not_available_or_no_availability_count,

  //Номер телефона недействителен
  phone_number_is_not_valid,

  //Телефон уже существует
  phone_already_exists,

  //Отзыв уже существует
  review_already_exists,

  //Отзыв или коммент не существует
  review_or_comment_does_not_exist
}

//Данные об ошибке, возвращаемые с api
export interface IErrorResponse {
  error: boolean;
  error_code: ApiErrorCode;
  message: string;
}